module.exports = __webpack_public_path__ + "static/media/facebook.ac17e4d5.svg";